/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_TitleInputs */

const en_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Voice Agents`)
};

const ar_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكلاء صوتيون بالذكاء الاصطناعي`)
};

const bn_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এআই ভয়েস এজেন্ট`)
};

const de_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Sprachagenten`)
};

const es_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes de voz con IA`)
};

const fr_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents vocaux IA`)
};

const pt_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes de voz com IA`)
};

const zh_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 语音助手`)
};

const tr_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay Zekâ Sesli Asistanlar`)
};

const ru_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голосовые агенты ИИ`)
};

const pl_svc_ai_voice_agents_title = /** @type {(inputs: Svc_Ai_Voice_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenci głosowi AI`)
};

/**
* | output |
* | --- |
* | "AI Voice Agents" |
*
* @param {Svc_Ai_Voice_Agents_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_title = /** @type {((inputs?: Svc_Ai_Voice_Agents_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_title(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_title(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_title(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_title(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_title(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_title(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_title(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_title(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_title(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_title(inputs)
	return en_svc_ai_voice_agents_title(inputs)
});
export { svc_ai_voice_agents_title as "svc_ai-voice-agents_title" }